export enum ModalMonthType {
    SPECIFIC_MONTH = 'SPECIFIC_MONTH',
    SAP_CURRENT_MONTH = 'SAP_CURRENT_MONTH',
    SAP_PREVIOUS_MONTH = 'SAP_PREVIOUS_MONTH',
}
